import { customDatalabelsPlugin } from './plugins/customDatalabelsPlugin';

export const pieChartConfig = ({ animate = true }) => ({
  type: 'pie',
  aspectRatio: 1.3,
  options: {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    ...(animate ? {} : { animations: false }),
  },
});

export const pieChartConfigSeeding = () => ({
  type: 'pie',
  aspectRatio: 1,
  plugins: [customDatalabelsPlugin],
  options: {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
  },
});
